"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userSchema = void 0;
const zod_1 = require("zod");
// Схема для User
exports.userSchema = zod_1.z.object({
  id: zod_1.z.string(),
  email: zod_1.z.string().email().optional(),
  name: zod_1.z.string().optional(),
  surname: zod_1.z.string().optional(),
  avatar: zod_1.z.string().optional(),
  status: zod_1.z.string().optional(),
  role: zod_1.z.string().optional(),
  language_id: zod_1.z.number().optional(),
  subject_id: zod_1.z.number().optional(),
  level_id: zod_1.z.number().optional(),
  bio: zod_1.z.string().optional(),
  rating: zod_1.z.number().optional(),
  rating_total: zod_1.z.number().optional(),
  is_available: zod_1.z.boolean().optional(),
  is_verified: zod_1.z.boolean().optional(),
  is_online: zod_1.z.boolean().optional(),
  last_activity: zod_1.z.string().optional()
})
// TODO: remove catchall, need to define all fields
.catchall(zod_1.z.any()); // для других полей
